import cleanSvg from "../svg/cleanSvg";
import {makePngFromSvg} from "../svg/makePngFromSvg";
import store from "../../../store";
import {snapshot} from "valtio";
import {v4 as uuidv4} from 'uuid';


import createTextImage from "../svg/createTextImage";
import {convertToSvg} from "../svg/convertToSvg";
import manageConcurrentRequest, {sendRequest} from "./util/manageConcurrentRequest";
import cacheImages from "../svg/cacheImages";
import getBoundingBoxByAngle from "../svg/getBoundingBoxByAngle";



const addNewListTextsElement = async (text, sectionId, oldId, listTexts = {}) => {
    return new Promise(async (resolve, reject) => {

        // create new id if not exist
        const id = oldId || uuidv4()
        const snap = snapshot(store);


        // Manage request queue
        const requestId = await manageConcurrentRequest(id)
        if (!requestId) {
            resolve(null)
            return null
        } // If request is canceled

        //console.log("requestId", requestId)
        // Initialize variables
        let currentElement = null
        let currentListTexts = {}

        // Get current element if request is an update
        if (oldId) {
            currentElement = snap.elements.find(e => e.elementId === oldId)
            const {string, ...rest} = currentElement.listTexts;
            currentListTexts = rest
            URL.revokeObjectURL(currentElement.image);
        }
        
        // Set default style
        
        let defaultListData = {
            fontSize: 10,
            fontFamily: 'Fasthand',
            fontStyle: 'Fasthand-Regular',
            list: [],
            previewIndex: 0,
            maxHeight: 15,
            fileName: null,
            string: text,
            ...currentListTexts,
            ...listTexts,
        }
        
        
        const increaseQuality = 20;
        const section = snap.sections.find(e => e.section_id === sectionId) //Get section
        const textBoxWidth = currentElement?.width || section?.width
        const maxHeight = (section.height * (defaultListData.maxHeight / 100)) * increaseQuality;

        const textImage = await sendRequest(requestId, createTextImage, text, defaultListData)

        const svgCode = await sendRequest(requestId, convertToSvg, URL.createObjectURL(textImage))
        const changedSvg = await sendRequest(requestId, cleanSvg, svgCode, textBoxWidth * increaseQuality, maxHeight  ) //Clean svg and change size
        const imgData = await sendRequest(requestId, makePngFromSvg, changedSvg.svg)


        if (!imgData) {
            resolve(false)
            return null
        }

        await cacheImages(imgData.blob, id)
        
  
        let imageWidth = textBoxWidth
        let imageHeight = imgData.height / increaseQuality


        const snapping = await getBoundingBoxByAngle({
            width: imageWidth,
            height: imageHeight,
            angle: 0,
            outline: changedSvg.outline,
            offset_x: section.offset_x,
            offset_y: section.offset_Y,
            sectionWidth: section.width,
            sectionHeight: section.height,
            section_offset_y: section.offset_Y,
            lockMove: true
        })

        // Create element object
        let element = {
            sectionId: sectionId,
            elementId: id,
            index: currentElement?.index || snap.elements.length,
            visible: true,
            type: "listTexts",
            image: imgData.imgUrl,
         
            listTexts: defaultListData,//currentElement?.listTexts || {},
            
            outline: changedSvg.outline,
            snapping: snapping,
            needToCheck: false,
            width: imageWidth, //imgData.width / increaseQuality,
            height: imageHeight,//imgData.height / increaseQuality,
            offset_x: currentElement?.offset_x || section.offset_x,
            offset_y: currentElement?.offset_y || section.offset_Y,
            radialAngle: currentElement?.radialAngle || section.radial_angle,
            angle: currentElement?.angle || section.angle || 0,
            lastUpdate: Date.now(),
            
            insideData: {
                intersect: true, // If the element is intersecting the section
                isInside: true, // If the element is intersecting the section
                points: [true, true, true, true] // Points of the element that are inside the section
            },
            lockMove: true,
            /*custom: {
                listData: isPreview ? currentElement?.custom.listData : [],
                fileName:isPreview ? currentElement?.custom.fileName : null
            },*/
        }
        
        /*// Clone listTexts.list array to avoid mutation on the original object
        let updatedList = element.listTexts.list.map(el => {
            if (el.text === text) {
                return {
                    ...el,
                    image: imgData.imgUrl
                };
            }
            return el;
        });
        
        // Assign the cloned and updated array back to element.listTexts.list
        element.listTexts = {
            ...element.listTexts,
            list: updatedList
        };*/
        
        

        // Update store
        if (oldId) {
            const index = snap.elements.findIndex(e => e.elementId === oldId)
            URL.revokeObjectURL(store.elements[index].image)
            store.elements[index].text = element.text
            store.elements[index] = element
            store.editElement = element
        } else {
            store.elements.push(element)
        }

        const threeViewerSection = window.threeViewer.scene.children.find(e => e.userData.id === sectionId && e.type === "section");

        threeViewerSection.update()
        threeViewerSection.helper.show(element)

        store.selectedElementId = id
        store.ui.addModalVisibility = false
        store.ui.zoom = sectionId
       
        // Generate decal and resolve
        //const decal = await generateElement(element, oldId)
        resolve(element)
    })
}

export default addNewListTextsElement;